import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.css']
})
export class OptionsComponent implements OnInit {
  visible = false;
  options = {
    showHelp: false,
    autoVisible: false
  };

  constructor() { }

  ngOnInit() {
    this.options = JSON.parse(localStorage.getItem('options')) || { showHelp: false, autoVisible: false };
    this.sendEvent();
  }

  toggleVisible() {
    this.visible = !this.visible;
  }

  setOption(key, value) {
    this.options[key] = value;
    localStorage.setItem('options', JSON.stringify(this.options));
    this.sendEvent();
  }

  sendEvent() {
    let event = new Event("options");
    window.dispatchEvent(event);
  }

  handleChange(e) {
    const key = e.target.name;
    const value = e.target.checked;
    this.setOption(key, value);
  }
}
